import React from 'react';

import BasePill from '../BasePill';
import type { CounterPillProps } from './types';
import { getCounterPillClasses } from './utils';

const CounterPill = React.forwardRef<HTMLDivElement, CounterPillProps>((props, ref) => {
  const { appearance = 'primary', className, label, size = 'small', ...rest } = props;
  const classes = getCounterPillClasses(size, appearance);

  return <BasePill ref={ref} className={className} classes={classes} label={label} {...rest} />;
});

export default React.memo(CounterPill);
